import { CSSProperties, Fragment } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';

import { useLanguage } from '../../hooks';
import { commonStyles } from '../../style/CommonStyles';
import { customStyles } from './MainMenu';

interface MainMenuItemProps {
  item: MenuItemData;
  expandedDesktop: boolean;
}

export interface MenuItemData {
  label: string;
  icon: any;
  path: string;
  hide?: boolean;
  forceRerender?: boolean;
  notification?: number;
  new?: boolean;
}

export function MainMenuItem({ item, expandedDesktop }: MainMenuItemProps) {
  const lang = useLanguage();
  const location = useLocation();

  return (
    <Fragment key={item.label}>
      <NavLink
        key={item.label}
        to={item.path}
        reloadDocument={item.forceRerender && location.pathname === item.path}
        style={commonStyles.linkOverride as CSSProperties}
      >
        {({ isActive }) => (
          <Tooltip
            title={item.label}
            placement='right'
            arrow
            disableHoverListener={expandedDesktop}
          >
            <ListItemButton
              sx={{
                ...customStyles.menuItem,
                ...(isActive && {
                  backgroundColor: '#6DB1FB',
                }),
              }}
            >
              <ListItemIcon>
                {item.icon}
                {item.notification > 0 && !expandedDesktop && (
                  <Box sx={customStyles.notificationCollapsed}>{item.notification}</Box>
                )}
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box sx={customStyles.menuItemText}>
                    {item.label}
                    {item.notification > 0 && expandedDesktop && (
                      <Box sx={customStyles.notification}>{item.notification}</Box>
                    )}
                  </Box>
                }
                sx={{
                  ...(!expandedDesktop && customStyles.unexpandedDesktopItem),
                }}
              />
              {item.new && expandedDesktop && (
                <Typography
                  component='span'
                  sx={customStyles.new}
                >
                  {lang.mainMenu.new}
                </Typography>
              )}
            </ListItemButton>
          </Tooltip>
        )}
      </NavLink>
    </Fragment>
  );
}
